import FileSaver from 'file-saver';

// Génération CSV côté navigateur (B4_01). Séparateur ';' = convention Excel FR (laisse la
// virgule libre comme séparateur décimal côté appelant). Les valeurs sont passées déjà
// formatées par les composants (l'export est fidèle à l'affiché — cf. ticket B4_01).
const SEP = ';';
const EOL = '\r\n';

// Échappe un champ : entouré de guillemets (avec doublage des guillemets internes) seulement
// s'il contient le séparateur, un guillemet ou un saut de ligne. null/undefined → chaîne vide.
// Anti-injection de formule (CSV injection) : Excel/LibreOffice exécutent une cellule commençant
// par = + - @ (ou tab/CR). Or `plugin_version`/`locale` proviennent du POST survey ANONYME
// (B1_02, soumis par n'importe qui) → on neutralise en préfixant d'une apostrophe. Aucun champ
// légitime de cet export (libellés FR, entiers ≥0, pourcentages positifs) ne commence par ces
// caractères, donc le préfixe ne touche que les valeurs malveillantes.
function escapeField(value) {
  let s = value == null ? '' : String(value);
  if (/^[=+\-@\t\r]/.test(s)) {
    s = `'${s}`;
  }
  if (s.indexOf(SEP) !== -1 || s.indexOf('"') !== -1 || s.indexOf('\n') !== -1 || s.indexOf('\r') !== -1) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

// Sérialise un tableau de lignes en CSV. Chaque ligne = tableau de cellules ; une ligne vide
// (`[]`) produit une ligne blanche, utilisée comme séparateur de sections (feedbacks = 3 tables).
export function rowsToCSV(rows) {
  return rows
    .map((row) => (Array.isArray(row) ? row.map(escapeField).join(SEP) : ''))
    .join(EOL);
}

// Déclenche le téléchargement d'un CSV. BOM UTF-8 en tête pour qu'Excel détecte l'encodage
// (sinon les accents sont cassés). Réutilise file-saver (déjà embarqué, cf. Bills.js).
export function downloadCSV(filename, csvString) {
  const BOM = '﻿';
  const blob = new Blob([BOM + csvString], { type: 'text/csv;charset=utf-8' });
  FileSaver.saveAs(blob, filename);
}

export default { rowsToCSV, downloadCSV };
